import * as e from "react";
import { useState as A, useEffect as Z, useRef as J, useCallback as _e, Fragment as ct } from "react";
import { p as Qe, e as lt, o as it, h as dt, d as _t } from "./format-CVedM0M8.js";
import { A as Cl, a as Sl, b as Bl, c as Fl, f as Il, g as jl, i as Ll, j as Dl, k as Ml, l as Tl, m as Rl, n as Pl, s as Ol, t as ql } from "./format-CVedM0M8.js";
import { cd as Ye } from "./OBTResizeContainer-Bj7BOMha.js";
import { A as Wl, a as zl, b as Kl, c as Hl, d as Vl, e as Ul, C as Ql, f as Yl, g as Jl, h as Zl, i as ei, j as ti, k as ai, l as ni, m as oi, n as si, o as ri, p as ci, q as li, r as ii, s as di, t as _i, u as mi, v as ui, w as pi, x as Ei, y as bi, z as fi, B as yi, D as gi, E as hi, F as vi, G as ki, H as Ni, I as Ai, J as wi, K as $i, L as xi, M as Xi, N as Ci, O as Si, P as Bi, Q as Fi, R as Ii, S as ji, T as Li, U as Di, V as Mi, W as Ti, X as Ri, Y as Pi, Z as Oi, _ as qi, $ as Gi, a0 as Wi, a1 as zi, a2 as Ki, a3 as Hi, a4 as Vi, a5 as Ui, a6 as Qi, a7 as Yi, a8 as Ji, a9 as Zi, aa as ed, ab as td, ac as ad, ad as nd, ae as od, af as sd, ag as rd, ah as cd, ai as ld, aj as id, ak as dd, al as _d, am as md, an as ud, ao as pd, ap as Ed, aq as bd, ar as fd, as as yd, at as gd, au as hd, av as vd, aw as kd, ax as Nd, ay as Ad, az as wd, aA as $d, aB as xd, aC as Xd, aD as Cd, aE as Sd, aF as Bd, aG as Fd, aH as Id, aI as jd, aJ as Ld, aK as Dd, aL as Md, aM as Td, aN as Rd, aO as Pd, aP as Od, aQ as qd, ce as Gd, aR as Wd, aS as zd, aT as Kd, aU as Hd, aV as Vd, aW as Ud, aX as Qd, aY as Yd, aZ as Jd, a_ as Zd, a$ as e_, b0 as t_, b1 as a_, b2 as n_, b3 as o_, b4 as s_, b5 as r_, b6 as c_, b7 as l_, b8 as i_, b9 as d_, ba as __, bb as m_, bc as u_, bd as p_, be as E_, bf as b_, bg as f_, bh as y_, bi as g_, bj as h_, bk as v_, bl as k_, bm as N_, bn as A_, bo as w_, bp as $_, bq as x_, br as X_, bs as C_, bt as S_, bu as B_, bv as F_, bw as I_, bx as j_, by as L_, bz as D_, bA as M_, bB as T_, bC as R_, bD as P_, bE as O_, bF as q_, bG as G_, bH as W_, bI as z_, bJ as K_, bK as H_, bL as V_, bM as U_, bN as Q_, bO as Y_, bP as J_, bQ as Z_, bR as em, bS as tm, bT as am, bU as nm, bV as om, bW as sm, bX as rm, bY as cm, bZ as lm, b_ as im, b$ as dm, c0 as _m, c1 as mm, c2 as um, c3 as pm, c4 as Em, c5 as bm, c6 as fm, c7 as ym, c8 as gm, c9 as hm, ca as vm, cb as km, cc as Nm } from "./OBTResizeContainer-Bj7BOMha.js";
const Rc = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, Ie = "poc_portal_token", ge = "poc_portal_refresh", Ce = "auth:session-expired", je = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let Je = je + "/chat-api/api/auth";
function Pc(t) {
  t.authBase && (Je = t.authBase);
}
function $e(t) {
  try {
    const a = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(a))));
  } catch {
    return {};
  }
}
function mt(t, a = 30) {
  const n = $e(t).exp;
  return !n || n * 1e3 < Date.now() + a * 1e3;
}
function Ze(t = 30) {
  const a = localStorage.getItem(ge);
  if (!a) return !0;
  const n = $e(a).exp;
  return !!n && n * 1e3 < Date.now() + t * 1e3;
}
function et() {
  return localStorage.getItem(Ie);
}
function ut(t, a) {
  localStorage.setItem(Ie, t), a && localStorage.setItem(ge, a);
}
function pt() {
  localStorage.removeItem(Ie), localStorage.removeItem(ge), tt();
}
function fe() {
  pt(), window.dispatchEvent(new Event(Ce));
}
function Oc(t) {
  return window.addEventListener(Ce, t), () => window.removeEventListener(Ce, t);
}
let ye = null;
const Et = 2147483647;
function bt() {
  if (tt(), Ze()) {
    fe();
    return;
  }
  const t = localStorage.getItem(ge), a = t ? $e(t).exp : void 0;
  if (!a) return;
  const n = Math.min(Math.max(a * 1e3 - Date.now() - 30 * 1e3, 0), Et);
  ye = setTimeout(() => {
    ye = null, bt();
  }, n);
}
function tt() {
  ye !== null && (clearTimeout(ye), ye = null);
}
let Ae = null;
function at() {
  return Ae || (Ae = ft()), Ae;
}
async function ft() {
  try {
    return await yt();
  } finally {
    Ae = null;
  }
}
async function yt() {
  const t = localStorage.getItem(ge);
  if (!t)
    return fe(), null;
  let a;
  try {
    a = await fetch(Je + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: t })
    });
  } catch {
    return null;
  }
  if (!a.ok)
    return a.status < 500 && fe(), null;
  const n = await a.json().catch(() => ({}));
  return n.access_token ? (ut(n.access_token, n.refresh_token), n.access_token) : (fe(), null);
}
async function gt() {
  if (Ze())
    return fe(), null;
  const t = et();
  return t && !mt(t) ? t : at();
}
const we = "poc_portal_active_aff:", ht = "X-Active-Com", vt = "X-Active-Dept";
function Le(t = et()) {
  return t && $e(t).preferred_username || null;
}
function Se(t) {
  if (!t) return null;
  try {
    const a = JSON.parse(t);
    if (Number.isInteger(a == null ? void 0 : a.comSq) && typeof (a == null ? void 0 : a.deptCd) == "string" && a.deptCd)
      return { comSq: a.comSq, deptCd: a.deptCd };
  } catch {
  }
  return null;
}
function De(t = Le()) {
  if (!t) return null;
  try {
    return Se(localStorage.getItem(we + t));
  } catch {
    return null;
  }
}
function qc(t, a) {
  if (t)
    try {
      a ? localStorage.setItem(we + t, JSON.stringify(a)) : localStorage.removeItem(we + t);
    } catch {
    }
}
function Gc(t) {
  const a = (n) => {
    const o = Le();
    if (!o || n.key !== we + o) return;
    const r = Se(n.oldValue), s = Se(n.newValue);
    (r == null ? void 0 : r.comSq) === (s == null ? void 0 : s.comSq) && (r == null ? void 0 : r.deptCd) === (s == null ? void 0 : s.deptCd) || t(s, r);
  };
  return window.addEventListener("storage", a), () => window.removeEventListener("storage", a);
}
function kt(t) {
  const a = De(Le(t));
  return a ? { [ht]: String(a.comSq), [vt]: a.deptCd } : {};
}
async function le(t, a = {}) {
  const n = (s) => {
    var m;
    const l = (m = a.headers) != null ? m : {}, d = Object.keys(l).map((_) => _.toLowerCase()), c = kt(s), i = {};
    return Object.keys(c).forEach((_) => {
      d.indexOf(_.toLowerCase()) < 0 && (i[_] = c[_]);
    }), {
      ...a,
      headers: { ...l, ...s ? { Authorization: "Bearer " + s } : {}, ...i }
    };
  }, o = await gt();
  let r = await fetch(t, n(o));
  if (r.status === 401 && o) {
    const s = await at();
    s && (r = await fetch(t, n(s)));
  }
  return r;
}
const Me = "JPY";
let ve = null;
function nt() {
  return ve || (ve = le(`${je}/chat-api/api/basicinfo/common/companies`).then((t) => t.ok ? t.json() : []).catch(() => []).then((t) => (t.length || (ve = null), t))), ve;
}
function Nt(t, a) {
  var o, r, s;
  const n = (o = t.find((l) => l.comSq === a)) != null ? o : t[0];
  return n && (s = (r = n.dispCurCd) != null ? r : n.baseCurCd) != null ? s : null;
}
function Wc() {
  return nt().then((t) => {
    var n;
    const a = ot(t, (n = De()) == null ? void 0 : n.comSq);
    a && Qe(a);
  }, () => {
  });
}
function ot(t, a) {
  var o, r;
  const n = (o = t.find((s) => s.comSq === a)) != null ? o : t[0];
  return (r = n == null ? void 0 : n.baseCurCd) != null ? r : null;
}
function At(t, a) {
  return { code: t, digits: _t(t), fmt: (n) => dt(n, t), unit: it(t, a), text: lt(t, a) };
}
function wt(t) {
  const [a, n] = A(Me), [o, r] = A(Me);
  return Z(() => {
    let s = !0;
    return nt().then((l) => {
      var m;
      const d = (m = De()) == null ? void 0 : m.comSq, c = Nt(l, d), i = ot(l, d);
      s && (c && n(c), i && (r(i), Qe(i)));
    }), () => {
      s = !1;
    };
  }, []), At(a, { base: o, ...t });
}
function zc({ className: t, hideBaseUnit: a = !0 }) {
  const { unit: n } = wt({ hideBaseUnit: a });
  return n ? /* @__PURE__ */ e.createElement("span", { className: t, "data-currency-unit": !0 }, n) : null;
}
let ie = je + "/chat-api/api/comments";
function Kc(t) {
  t.base && (ie = t.base);
}
function $t(t) {
  return t.parentId !== void 0 && t.parentId !== null;
}
async function he(t) {
  const a = await t.json().catch(() => ({}));
  if (!t.ok) throw new Error("요청을 처리하지 못했습니다. 잠시 후 다시 시도하세요.");
  return a;
}
async function Te(t, a, n, o, r) {
  const s = new URLSearchParams({ targetType: t, targetId: a, page: String(n), size: String(o) }), l = await le(`${ie}?${s}`, { cache: "no-store", signal: r });
  return he(l);
}
async function xt(t, a, n, o) {
  const r = await le(ie, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: t, targetId: a, content: n, parentId: o })
  });
  return he(r);
}
async function Xt(t, a) {
  const n = await le(`${ie}/${t}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: a })
  });
  return he(n);
}
async function Ct(t) {
  const a = await le(`${ie}/${t}`, { method: "DELETE" });
  return (await he(a)).status;
}
async function St(t, a, n) {
  if (a.length === 0) return {};
  const o = new URLSearchParams({ targetType: t, targetIds: a.join(",") }), r = await le(`${ie}/counts?${o}`, { cache: "no-store", signal: n });
  return (await he(r)).counts;
}
const Re = 50;
function Be(t) {
  return t.parentId === void 0 || t.parentId === null;
}
function Bt(t, a) {
  if (Be(a)) return [...t, a];
  const n = a.parentId;
  let o = -1;
  for (let r = 0; r < t.length; r += 1)
    (t[r].id === n || t[r].parentId === n) && (o = r);
  return o < 0 ? [...t, a] : [...t.slice(0, o + 1), a, ...t.slice(o + 1)];
}
function me(t, a) {
  return a;
}
function Ft(t, a) {
  const [n, o] = A([]), [r, s] = A(!0), [l, d] = A(!0), [c, i] = A(null), [m, _] = A(0), [u, b] = A(0), y = t + " " + a, E = J(y);
  E.current = y;
  const [h, w] = A(0), X = _e(() => w((f) => f + 1), []);
  Z(() => {
    const f = new AbortController(), v = y;
    return o([]), b(0), _(0), i(null), s(!0), d(!0), Te(t, a, 0, Re, f.signal).then((g) => {
      E.current === v && (o(g.items), _(g.total));
    }).catch((g) => {
      f.signal.aborted || E.current !== v || i(me(g, "댓글을 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && (s(!1), d(!1));
    }), () => f.abort();
  }, [t, a, y, h]);
  const O = n.filter(Be).length < m, q = _e(() => {
    if (r || !O) return;
    const f = u + 1, v = E.current;
    s(!0), Te(t, a, f, Re).then((g) => {
      E.current === v && (o((S) => [...S, ...g.items]), _(g.total), b(f));
    }).catch((g) => {
      E.current === v && i(me(g, "댓글을 더 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && s(!1);
    });
  }, [r, O, u, t, a]), V = _e(async (f, v) => {
    const g = f.trim();
    if (!g) return !1;
    const S = -Date.now(), B = {
      id: S,
      targetType: t,
      targetId: a,
      parentId: v != null ? v : null,
      authorName: "나",
      content: g,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, D = E.current;
    o((j) => Bt(j, B)), i(null);
    try {
      const j = await xt(t, a, g, v);
      return E.current !== D || (o((U) => U.map((k) => k.id === S ? j : k)), v === void 0 && _((U) => U + 1)), !0;
    } catch (j) {
      return E.current !== D || (o((U) => U.filter((k) => k.id !== S)), i(me(j, "댓글을 등록하지 못했습니다."))), !1;
    }
  }, [t, a]), C = _e(async (f, v) => {
    const g = v.trim();
    if (!g) return !1;
    const S = E.current;
    try {
      const B = await Xt(f, g);
      return E.current !== S || o((D) => D.map((j) => j.id === f ? B : j)), !0;
    } catch (B) {
      return E.current === S && i(me(B, "댓글을 수정하지 못했습니다.")), !1;
    }
  }, []), de = _e(async (f) => {
    const v = E.current;
    try {
      const g = await Ct(f);
      return E.current !== v ? !0 : g === "soft-deleted" ? (o((S) => S.map((B) => B.id === f ? { ...B, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : B)), !0) : (o((S) => {
        const B = S.find((k) => k.id === f), D = S.filter((k) => k.id !== f);
        if (!B) return D;
        if (Be(B))
          return _((k) => Math.max(0, k - 1)), D;
        const j = B.parentId, U = D.find((k) => k.id === j);
        return U && U.deleted && !D.some((k) => k.parentId === j) ? (_((k) => Math.max(0, k - 1)), D.filter((k) => k.id !== j)) : D;
      }), !0);
    } catch (g) {
      return E.current === v && i(me(g, "댓글을 삭제하지 못했습니다.")), !1;
    }
  }, []);
  return {
    items: n,
    loading: r,
    initialLoading: l,
    error: c,
    count: n.filter((f) => !f.deleted).length,
    hasMore: O,
    loadMore: q,
    reload: X,
    add: V,
    edit: C,
    remove: de
  };
}
const It = "_thread_1layy_9", jt = "_head_1layy_28", Lt = "_headTitle_1layy_37", Dt = "_headCount_1layy_43", Mt = "_list_1layy_54", Tt = "_row_1layy_61", Rt = "_isReply_1layy_73", Pt = "_pending_1layy_80", Ot = "_avatar_1layy_84", qt = "_avatarGhost_1layy_98", Gt = "_body_1layy_103", Wt = "_meta_1layy_108", zt = "_author_1layy_116", Kt = "_dept_1layy_122", Ht = "_time_1layy_130", Vt = "_text_1layy_135", Ut = "_textDeleted_1layy_143", Qt = "_acts_1layy_148", Yt = "_act_1layy_148", Jt = "_actDanger_1layy_169", Zt = "_empty_1layy_175", ea = "_error_1layy_182", ta = "_skeleton_1layy_196", aa = "_more_1layy_219", na = "_foot_1layy_245", oa = "_composer_1layy_252", sa = "_composerInput_1layy_261", ra = "_composerActions_1layy_284", ca = "_btn_1layy_291", la = "_btnPrimary_1layy_301", ia = "_btnGhost_1layy_310", p = {
  thread: It,
  head: jt,
  headTitle: Lt,
  headCount: Dt,
  list: Mt,
  row: Tt,
  isReply: Rt,
  pending: Pt,
  avatar: Ot,
  avatarGhost: qt,
  body: Gt,
  meta: Wt,
  author: zt,
  dept: Kt,
  time: Ht,
  text: Vt,
  textDeleted: Ut,
  acts: Qt,
  act: Yt,
  actDanger: Jt,
  empty: Zt,
  error: ea,
  skeleton: ta,
  more: aa,
  foot: na,
  composer: oa,
  composerInput: sa,
  composerActions: ra,
  btn: ca,
  btnPrimary: la,
  btnGhost: ia
}, Pe = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function da(t) {
  let a = 0;
  for (let n = 0; n < t.length; n += 1) a = (a * 31 + t.charCodeAt(n)) % 997;
  return Pe[a % Pe.length];
}
function _a(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "?";
}
const Oe = 6e4, qe = 36e5, Ge = 864e5, ma = 6048e5;
function ua(t) {
  const a = new Date(t).getTime();
  if (Number.isNaN(a)) return "";
  const n = Date.now() - a;
  if (n < Oe) return "방금";
  if (n < qe) return `${Math.floor(n / Oe)}분 전`;
  if (n < Ge) return `${Math.floor(n / qe)}시간 전`;
  if (n < ma) return `${Math.floor(n / Ge)}일 전`;
  const o = new Date(a), r = (s) => s < 10 ? `0${s}` : String(s);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function Fe({
  placeholder: t,
  submitLabel: a,
  autoFocus: n,
  initialValue: o,
  onSubmit: r,
  onCancel: s
}) {
  const [l, d] = A(o != null ? o : ""), [c, i] = A(!1), m = J(null);
  Z(() => {
    n && m.current && m.current.focus();
  }, [n]);
  const _ = async () => {
    const u = l.trim();
    if (!u || c) return;
    i(!0);
    const b = await r(u);
    i(!1), b && d("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: p.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: m,
      className: p.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: t,
      value: l,
      disabled: c,
      onChange: (u) => d(u.target.value),
      onKeyDown: (u) => {
        const b = u.nativeEvent.isComposing;
        u.key === "Enter" && !u.shiftKey && !b && (u.preventDefault(), _()), u.key === "Escape" && s && (u.nativeEvent.stopPropagation(), s());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: p.composerActions }, s && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: s,
      disabled: c
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnPrimary}`,
      onClick: () => void _(),
      disabled: c || !l.trim()
    },
    c ? "보내는 중…" : a
  )));
}
function pa({
  item: t,
  replying: a,
  editing: n,
  onReply: o,
  onEdit: r,
  onSubmitReply: s,
  onSubmitEdit: l,
  onDelete: d,
  onCancel: c
}) {
  var u, b;
  const i = $t(t), m = i ? ` ${p.isReply}` : "";
  if (t.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}` }, /* @__PURE__ */ e.createElement("span", { className: `${p.avatar} ${p.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: `${p.text} ${p.textDeleted}` }, "삭제된 댓글입니다")));
  const _ = (u = t.authorName) != null ? u : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}${t.pending ? ` ${p.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: p.avatar, style: { background: da(_) } }, _a(_)), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: p.meta }, /* @__PURE__ */ e.createElement("span", { className: p.author }, _), t.dept && /* @__PURE__ */ e.createElement("span", { className: p.dept }, t.dept), /* @__PURE__ */ e.createElement("span", { className: p.time }, ua(t.createdAt)), t.updatedAt && /* @__PURE__ */ e.createElement("span", { className: p.time }, "(수정됨)")), n ? /* @__PURE__ */ e.createElement(
    Fe,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (b = t.content) != null ? b : "",
      onSubmit: l,
      onCancel: c
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: p.text }, t.content), !n && !t.pending && /* @__PURE__ */ e.createElement("div", { className: p.acts }, !i && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: o }, "답글"), t.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: r }, "수정"), t.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.act} ${p.actDanger}`,
      onClick: d
    },
    "삭제"
  )), a && /* @__PURE__ */ e.createElement(
    Fe,
    {
      placeholder: `${_} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: s,
      onCancel: c
    }
  )));
}
function Hc({
  targetType: t,
  targetId: a,
  onCountChange: n,
  autoFocus: o,
  showHeader: r = !0,
  className: s,
  style: l
}) {
  const { items: d, initialLoading: c, loading: i, error: m, count: _, hasMore: u, loadMore: b, reload: y, add: E, edit: h, remove: w } = Ft(t, a), [X, T] = A(null), [O, q] = A(null);
  Z(() => {
    T(null), q(null);
  }, [t, a]);
  const V = J(n);
  return V.current = n, Z(() => {
    !c && V.current && V.current(_);
  }, [_, c]), /* @__PURE__ */ e.createElement("div", { className: s ? `${p.thread} ${s}` : p.thread, style: l }, r && /* @__PURE__ */ e.createElement("div", { className: p.head }, /* @__PURE__ */ e.createElement("span", { className: p.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: p.headCount }, _)), /* @__PURE__ */ e.createElement("div", { className: p.list }, c && /* @__PURE__ */ e.createElement("div", { className: p.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), m && /* @__PURE__ */ e.createElement("div", { className: p.error }, /* @__PURE__ */ e.createElement("span", null, m), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: y
    },
    "다시 시도"
  )), !c && !m && d.length === 0 && /* @__PURE__ */ e.createElement("div", { className: p.empty }, "첫 댓글을 남겨 보세요."), d.map((C) => /* @__PURE__ */ e.createElement(
    pa,
    {
      key: C.id,
      item: C,
      replying: X === C.id,
      editing: O === C.id,
      onReply: () => {
        q(null), T(C.id);
      },
      onEdit: () => {
        T(null), q(C.id);
      },
      onCancel: () => {
        T(null), q(null);
      },
      onSubmitReply: async (de) => {
        const f = await E(de, C.id);
        return f && T(null), f;
      },
      onSubmitEdit: async (de) => {
        const f = await h(C.id, de);
        return f && q(null), f;
      },
      onDelete: () => {
        w(C.id);
      }
    }
  )), u && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.more, onClick: b, disabled: i }, i ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: p.foot }, /* @__PURE__ */ e.createElement(
    Fe,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (C) => E(C)
    }
  )));
}
function Vc(t, a) {
  const [n, o] = A({}), [r, s] = A(!1), [l, d] = A(0), c = a.join(",");
  return Z(() => {
    const i = c ? c.split(",") : [];
    if (i.length === 0) {
      o({});
      return;
    }
    const m = new AbortController();
    return s(!0), St(t, i, m.signal).then((_) => {
      m.signal.aborted || o(_);
    }).catch(() => {
      m.signal.aborted || o({});
    }).finally(() => {
      m.signal.aborted || s(!1);
    }), () => m.abort();
  }, [t, c, l]), {
    counts: n,
    loading: r,
    reload: () => d((i) => i + 1)
  };
}
const Ea = "_card_epi3f_1", ba = "_header_epi3f_8", fa = "_headerNoDivider_epi3f_13", ya = "_body_epi3f_17", ga = "_paddingSm_epi3f_22", ha = "_paddingMd_epi3f_26", va = "_paddingLg_epi3f_30", G = {
  card: Ea,
  header: ba,
  headerNoDivider: fa,
  body: ya,
  paddingSm: ga,
  paddingMd: ha,
  paddingLg: va
};
function Uc({
  children: t,
  header: a,
  padding: n = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: s,
  headerPadding: l,
  headerBorderColor: d,
  className: c
}) {
  const i = typeof n == "number" ? "" : n === "sm" ? G.paddingSm : n === "lg" ? G.paddingLg : G.paddingMd, m = typeof n == "number" ? { padding: n } : void 0, _ = c ? `${G.card} ${c}` : G.card, u = r ? G.header : `${G.header} ${G.headerNoDivider}`, b = {
    ...s !== void 0 ? { background: s } : {},
    ...l !== void 0 ? { padding: l } : {},
    ...d !== void 0 ? { borderBottomColor: d } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: _, style: o !== void 0 ? { borderRadius: o } : void 0 }, a && /* @__PURE__ */ e.createElement("div", { className: u, style: b }, a), /* @__PURE__ */ e.createElement("div", { className: `${G.body} ${i}`, style: m }, t));
}
const ka = "_horizontal_mkht7_1", Na = "_vertical_mkht7_8", We = {
  horizontal: ka,
  vertical: Na
};
function Qc({ orientation: t = "horizontal", spacing: a = 0, color: n }) {
  const o = t === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o ? We.vertical : We.horizontal,
      style: {
        ...o ? { marginLeft: a, marginRight: a } : { marginTop: a, marginBottom: a },
        ...n !== void 0 ? { backgroundColor: n } : {}
      },
      role: "separator",
      "aria-orientation": t
    }
  );
}
const Aa = "_root_nvy8t_1", wa = "_icon_nvy8t_7", $a = "_iconBadge_nvy8t_15", xa = "_titleGroup_nvy8t_25", Xa = "_title_nvy8t_25", Ca = "_subtitle_nvy8t_41", Sa = "_trailing_nvy8t_49", Ba = "_closeButton_nvy8t_58", Q = {
  root: Aa,
  icon: wa,
  iconBadge: $a,
  titleGroup: xa,
  title: Xa,
  subtitle: Ca,
  trailing: Sa,
  closeButton: Ba
};
function Yc({
  icon: t,
  iconColor: a,
  iconBadge: n = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: s,
  title: l,
  titleWeight: d,
  titleSize: c,
  subtitle: i,
  subtitleColor: m,
  subtitleSize: _,
  trailing: u,
  onClose: b
}) {
  const y = {
    ...d !== void 0 ? { fontWeight: d } : {},
    ...c !== void 0 ? { fontSize: c } : {}
  }, E = {
    ...m !== void 0 ? { color: m } : {},
    ..._ !== void 0 ? { fontSize: _ } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: Q.root }, t && n && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Q.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...s !== void 0 ? { width: s, height: s } : {}
      }
    },
    t
  ), t && !n && /* @__PURE__ */ e.createElement("span", { className: Q.icon, style: a !== void 0 ? { color: a } : void 0 }, t), /* @__PURE__ */ e.createElement("div", { className: Q.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: Q.title, style: y }, l), i && /* @__PURE__ */ e.createElement("span", { className: Q.subtitle, style: E }, i)), u && /* @__PURE__ */ e.createElement("div", { className: Q.trailing }, u), b && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: Q.closeButton,
      onClick: b,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const Fa = "_badge_19977_1", Ia = {
  badge: Fa
};
function Jc({
  size: t = 32,
  gradient: a = ["#7C3AED", "#3B82F6"],
  icon: n
}) {
  const o = t * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ia.badge,
      style: {
        width: t,
        height: t,
        background: `linear-gradient(135deg, ${a[0]}, ${a[1]})`
      }
    },
    n != null ? n : /* @__PURE__ */ e.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const ja = "_wrapper_ccmq2_1", La = "_image_ccmq2_8", Da = "_fallback_ccmq2_16", Ma = "_statusDot_ccmq2_29", ke = {
  wrapper: ja,
  image: La,
  fallback: Da,
  statusDot: Ma
}, Ta = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function Ra(t) {
  const a = t == null ? void 0 : t.trim();
  return a ? Array.from(a)[0].toUpperCase() : "";
}
const xe = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function Pa(t) {
  const a = t == null ? void 0 : t.trim();
  if (!a) return xe[5];
  let n = 0;
  for (let o = 0; o < a.length; o += 1)
    n = n * 31 + a.charCodeAt(o) | 0;
  return xe[Math.abs(n) % xe.length];
}
function st({
  src: t,
  fallbackText: a,
  alt: n,
  size: o = 32,
  statusDot: r,
  color: s,
  ring: l = !1,
  ringColor: d = "#fff"
}) {
  var _;
  const [c, i] = A(), m = !!t && c !== t;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ke.wrapper,
      style: {
        width: o,
        height: o,
        ...l ? { boxShadow: `0 0 0 2px ${d}` } : {}
      }
    },
    m ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: ke.image,
        src: t,
        alt: (_ = n != null ? n : a) != null ? _ : "",
        onError: () => i(t)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ke.fallback,
        style: {
          backgroundColor: s != null ? s : Pa(a),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      Ra(a)
    ),
    r && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ke.statusDot,
        style: {
          backgroundColor: Ta[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const Oa = "_stack_y8phg_1", qa = "_item_y8phg_6", Ga = "_overflow_y8phg_18", Ne = {
  stack: Oa,
  item: qa,
  overflow: Ga
};
function Zc({
  avatars: t,
  max: a = 4,
  size: n = 32
}) {
  const o = t.slice(0, a), r = t.length - o.length;
  return /* @__PURE__ */ e.createElement("span", { className: Ne.stack }, o.map((s, l) => /* @__PURE__ */ e.createElement("span", { key: l, className: Ne.item, style: { zIndex: o.length - l } }, /* @__PURE__ */ e.createElement(st, { src: s.src, alt: s.alt, fallbackText: s.fallbackText, size: n }))), r > 0 && /* @__PURE__ */ e.createElement("span", { className: Ne.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ne.overflow,
      style: { width: n, height: n, fontSize: Math.max(10, n * 0.36) }
    },
    "+",
    r
  )));
}
const Wa = "_badge_1mjda_1", za = "_pill_1mjda_15", Ka = "_dot_1mjda_19", Ha = "_dotPulse_1mjda_26", Va = "_outline_1mjda_40", Ua = "_soft_1mjda_46", ue = {
  badge: Wa,
  pill: za,
  dot: Ka,
  dotPulse: Ha,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: Va,
  soft: Ua
};
function el({
  label: t,
  variant: a = "default",
  color: n,
  background: o,
  textColor: r,
  shape: s = "rounded",
  dot: l = !1,
  dotColor: d,
  dotPulse: c = !1,
  border: i = !1,
  borderColor: m = "currentColor"
}) {
  var y;
  const _ = {};
  n && (a === "default" ? (_.backgroundColor = n, _.color = "#fff") : a === "outline" ? (_.borderColor = n, _.color = n) : (_.backgroundColor = `${n}1A`, _.color = n)), o !== void 0 && (_.backgroundColor = o), r !== void 0 && (_.color = r), i && (_.borderColor = m);
  const u = [
    ue.badge,
    ue[a],
    s === "pill" ? ue.pill : ""
  ].filter(Boolean).join(" "), b = [ue.dot, c ? ue.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: u, style: _ }, l && /* @__PURE__ */ e.createElement("span", { className: b, style: { backgroundColor: d != null ? d : (y = r != null ? r : n) != null ? y : "currentColor" } }), t);
}
const Qa = "_row_1k2ap_1", Ya = "_reply_1k2ap_7", Ja = "_avatar_1k2ap_12", Za = "_avatarImage_1k2ap_25", en = "_avatarFallback_1k2ap_32", tn = "_body_1k2ap_44", an = "_headerLine_1k2ap_49", nn = "_author_1k2ap_56", on = "_meta_1k2ap_62", sn = "_text_1k2ap_67", rn = "_actionsRow_1k2ap_74", cn = "_actionBtn_1k2ap_81", F = {
  row: Qa,
  reply: Ya,
  avatar: Ja,
  avatarImage: Za,
  avatarFallback: en,
  body: tn,
  headerLine: an,
  author: nn,
  meta: on,
  text: sn,
  actionsRow: rn,
  actionBtn: cn
};
function ln(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "";
}
function tl({
  avatarSrc: t,
  author: a,
  meta: n,
  text: o,
  likeCount: r,
  replyCount: s,
  isReply: l = !1,
  onLikeClick: d,
  onReplyClick: c
}) {
  const [i, m] = A(!1), _ = !!t && !i;
  return /* @__PURE__ */ e.createElement("div", { className: `${F.row} ${l ? F.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: F.avatar }, _ ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: F.avatarImage,
      src: t,
      alt: a,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: F.avatarFallback }, ln(a))), /* @__PURE__ */ e.createElement("div", { className: F.body }, /* @__PURE__ */ e.createElement("div", { className: F.headerLine }, /* @__PURE__ */ e.createElement("span", { className: F.author }, a), n && /* @__PURE__ */ e.createElement("span", { className: F.meta }, n)), /* @__PURE__ */ e.createElement("div", { className: F.text }, o), /* @__PURE__ */ e.createElement("div", { className: F.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: F.actionBtn, onClick: d }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ e.createElement("span", null, r)), /* @__PURE__ */ e.createElement("button", { type: "button", className: F.actionBtn, onClick: c }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof s == "number" && /* @__PURE__ */ e.createElement("span", null, s)))));
}
const dn = "_wrapper_79n51_1", _n = {
  wrapper: dn
}, mn = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, un = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function pn({ ext: t, size: a = 32 }) {
  var l;
  const n = t.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: s } = (l = mn[n]) != null ? l : un;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: _n.wrapper,
      style: {
        width: a,
        height: a,
        backgroundColor: s,
        color: r,
        fontSize: Math.max(8, a * 0.26)
      }
    },
    o
  );
}
const En = "_chip_1jhj8_1", bn = "_clickable_1jhj8_12", fn = "_icon_1jhj8_21", yn = "_info_1jhj8_26", gn = "_name_1jhj8_33", hn = "_size_1jhj8_42", vn = "_chipError_1jhj8_48", kn = "_chipDone_1jhj8_53", Nn = "_status_1jhj8_57", An = "_statusError_1jhj8_66", wn = "_statusDone_1jhj8_67", $n = "_statusIcon_1jhj8_69", xn = "_statusLabel_1jhj8_71", Xn = "_progressTrack_1jhj8_78", Cn = "_progressFill_1jhj8_88", Sn = "_actionBtn_1jhj8_96", N = {
  chip: En,
  clickable: bn,
  icon: fn,
  info: yn,
  name: gn,
  size: hn,
  chipError: vn,
  chipDone: kn,
  status: Nn,
  statusError: An,
  statusDone: wn,
  statusIcon: $n,
  statusLabel: xn,
  progressTrack: Xn,
  progressFill: Cn,
  actionBtn: Sn
};
function al({
  name: t,
  ext: a,
  size: n,
  onRemove: o,
  downloadable: r = !1,
  onClick: s,
  status: l,
  statusText: d,
  percent: c
}) {
  const i = l === "error" ? N.chipError : l === "done" ? N.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${N.chip} ${s ? N.clickable : ""} ${i}`,
      onClick: s,
      title: l === "error" ? d : void 0
    },
    a && /* @__PURE__ */ e.createElement("span", { className: N.icon }, /* @__PURE__ */ e.createElement(pn, { ext: a, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: N.info }, /* @__PURE__ */ e.createElement("span", { className: N.name }, t), d ? /* @__PURE__ */ e.createElement("span", { className: `${N.status} ${l === "error" ? N.statusError : l === "done" ? N.statusDone : ""}` }, l === "error" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: N.statusLabel }, d)) : n ? /* @__PURE__ */ e.createElement("span", { className: N.size }, n) : null, l === "processing" && /* @__PURE__ */ e.createElement("span", { className: N.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: N.progressFill, style: { width: `${Math.max(0, Math.min(100, c != null ? c : 0))}%` } }))),
    r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "내려받기",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "삭제",
        onClick: (m) => {
          m.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const Bn = "_list_1yxwc_1", Fn = "_row_1yxwc_6", In = "_inline_1yxwc_15", jn = "_label_1yxwc_22", Ln = "_value_1yxwc_29", Dn = "_stacked_1yxwc_35", Mn = "_bold_1yxwc_51", ne = {
  list: Bn,
  row: Fn,
  inline: In,
  label: jn,
  value: Ln,
  stacked: Dn,
  bold: Mn
};
function nl({
  rows: t,
  direction: a = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${ne.list} ${ne[a]}` }, t.map((n, o) => /* @__PURE__ */ e.createElement("div", { key: o, className: ne.row }, /* @__PURE__ */ e.createElement("span", { className: ne.label }, n.label), /* @__PURE__ */ e.createElement("span", { className: `${ne.value} ${n.bold ? ne.bold : ""}` }, n.value))));
}
const Tn = "_container_2r163_1", Rn = "_row_2r163_5", Pn = "_clickable_2r163_12", On = "_leading_2r163_20", qn = "_main_2r163_26", Gn = "_titleLine_2r163_34", Wn = "_title_2r163_34", zn = "_tags_2r163_50", Kn = "_meta_2r163_57", Hn = "_actions_2r163_62", Vn = "_expandable_2r163_69", M = {
  container: Tn,
  row: Rn,
  clickable: Pn,
  leading: On,
  main: qn,
  titleLine: Gn,
  title: Wn,
  tags: zn,
  meta: Kn,
  actions: Hn,
  expandable: Vn
};
function ol({
  leading: t,
  title: a,
  meta: n,
  tags: o,
  actions: r,
  expandableContent: s,
  expanded: l = !1,
  onClick: d
}) {
  return /* @__PURE__ */ e.createElement("div", { className: M.container }, /* @__PURE__ */ e.createElement("div", { className: `${M.row} ${d ? M.clickable : ""}`, onClick: d }, t && /* @__PURE__ */ e.createElement("div", { className: M.leading }, t), /* @__PURE__ */ e.createElement("div", { className: M.main }, /* @__PURE__ */ e.createElement("div", { className: M.titleLine }, /* @__PURE__ */ e.createElement("span", { className: M.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: M.tags }, o)), n && /* @__PURE__ */ e.createElement("div", { className: M.meta }, n)), r && /* @__PURE__ */ e.createElement("div", { className: M.actions, onClick: (c) => c.stopPropagation() }, r)), l && s && /* @__PURE__ */ e.createElement("div", { className: M.expandable }, s));
}
const Un = "_row_xzgny_1", Qn = "_info_xzgny_8", Yn = "_name_xzgny_16", Jn = "_subtitle_xzgny_25", Zn = "_status_xzgny_33", pe = {
  row: Un,
  info: Qn,
  name: Yn,
  subtitle: Jn,
  status: Zn
};
function sl({
  avatarSrc: t,
  name: a,
  subtitle: n,
  status: o,
  statusColor: r = "#64748B",
  statusBg: s = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: pe.row }, /* @__PURE__ */ e.createElement(st, { src: t, fallbackText: a, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: pe.info }, /* @__PURE__ */ e.createElement("span", { className: pe.name }, a), n && /* @__PURE__ */ e.createElement("span", { className: pe.subtitle }, n)), o && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: pe.status,
      style: { color: r, backgroundColor: s }
    },
    o
  ));
}
const eo = "_row_qoxwr_1", to = "_clickable_qoxwr_9", ao = "_rank_qoxwr_17", no = "_title_qoxwr_25", oo = "_trailing_qoxwr_36", Ee = {
  row: eo,
  clickable: to,
  rank: ao,
  title: no,
  trailing: oo
}, so = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function rl({
  rank: t,
  rankColor: a,
  title: n,
  trailingText: o,
  onClick: r
}) {
  var l;
  const s = (l = a != null ? a : so[t]) != null ? l : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${Ee.row} ${r ? Ee.clickable : ""}`, onClick: r }, /* @__PURE__ */ e.createElement("span", { className: Ee.rank, style: { color: s } }, t), /* @__PURE__ */ e.createElement("span", { className: Ee.title }, n), o && /* @__PURE__ */ e.createElement("span", { className: Ee.trailing }, o));
}
const ro = "_badge_1qibj_1", co = "_sm_1qibj_11", lo = "_md_1qibj_16", io = "_overdue_1qibj_21", _o = "_warning_1qibj_26", mo = "_progress_1qibj_31", uo = "_success_1qibj_36", po = "_info_1qibj_41", Eo = "_neutral_1qibj_46", Xe = {
  badge: ro,
  sm: co,
  md: lo,
  overdue: io,
  warning: _o,
  progress: mo,
  success: uo,
  info: po,
  neutral: Eo
};
function cl({
  label: t,
  tone: a = "neutral",
  size: n = "md",
  background: o,
  textColor: r
}) {
  const s = {};
  return o !== void 0 && (s.backgroundColor = o), r !== void 0 && (s.color = r), /* @__PURE__ */ e.createElement("span", { className: `${Xe.badge} ${Xe[a]} ${Xe[n]}`, style: s }, t);
}
const bo = "_wrapper_14p14_1", fo = "_avatar_14p14_11", yo = "_body_14p14_21", go = "_message_14p14_26", ho = "_dots_14p14_32", vo = "_dot_14p14_32", ko = "_action_14p14_70", No = "_actionIcon_14p14_89", Ao = "_gradientWrapper_14p14_95", wo = "_bareIcon_14p14_100", $o = "_ctaButton_14p14_109", $ = {
  wrapper: bo,
  avatar: fo,
  body: yo,
  message: go,
  dots: ho,
  dot: vo,
  action: ko,
  actionIcon: No,
  gradientWrapper: Ao,
  bareIcon: wo,
  ctaButton: $o
};
function ze() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function Ke() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function ll({
  message: t,
  accentColor: a = "#7C3AED",
  buttonLabel: n,
  buttonIcon: o,
  onAction: r,
  phase: s = "complete",
  variant: l = "card",
  gradientColors: d = ["#EEF4FF", "#F3EEFF"]
}) {
  const c = l === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [$.wrapper, c ? $.gradientWrapper : ""].join(" "),
      style: c ? { borderColor: `${a}33`, background: `linear-gradient(135deg, ${d[0]}, ${d[1]})` } : { borderColor: `${a}33` }
    },
    c ? /* @__PURE__ */ e.createElement("span", { className: $.bareIcon, style: { color: a } }, /* @__PURE__ */ e.createElement(ze, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: $.avatar,
        style: { backgroundColor: `${a}1A`, color: a }
      },
      /* @__PURE__ */ e.createElement(ze, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: $.body }, s === "loading" ? /* @__PURE__ */ e.createElement("span", { className: $.dots }, /* @__PURE__ */ e.createElement("span", { className: $.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: $.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: $.dot, style: { backgroundColor: a } })) : /* @__PURE__ */ e.createElement("span", { className: $.message, style: c ? { color: a } : void 0 }, t)),
    n && r && (c ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: $.ctaButton,
        style: { backgroundColor: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: $.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Ke, null) : o)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: $.action,
        style: { color: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: $.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Ke, null) : o)
    ))
  );
}
const xo = "_wrapper_68zkp_1", Xo = "_bordered_68zkp_13", Co = "_compact_68zkp_17", So = "_icon_68zkp_23", Bo = "_title_68zkp_31", Fo = "_description_68zkp_38", Io = "_action_68zkp_46", ee = {
  wrapper: xo,
  bordered: Xo,
  compact: Co,
  icon: So,
  title: Bo,
  description: Fo,
  action: Io
};
function jo() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function il({
  icon: t,
  hideIcon: a = !1,
  title: n,
  titleColor: o,
  titleSize: r,
  titleWeight: s,
  description: l,
  actionLabel: d,
  onAction: c,
  bordered: i = !0,
  compact: m = !1
}) {
  const _ = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [ee.wrapper, i && !m ? ee.bordered : "", m ? ee.compact : ""].join(" ")
    },
    !a && /* @__PURE__ */ e.createElement("div", { className: ee.icon }, t != null ? t : /* @__PURE__ */ e.createElement(jo, null)),
    /* @__PURE__ */ e.createElement("p", { className: ee.title, style: _ }, n),
    l && /* @__PURE__ */ e.createElement("p", { className: ee.description }, l),
    d && c && /* @__PURE__ */ e.createElement("button", { type: "button", className: ee.action, onClick: c }, d)
  );
}
const Lo = "_wrapper_oide4_1", Do = "_toggle_oide4_7", Mo = "_toggleOpen_oide4_29", To = "_panel_oide4_34", Ro = "_text_oide4_41", be = {
  wrapper: Lo,
  toggle: Do,
  toggleOpen: Mo,
  panel: To,
  text: Ro
};
function dl({
  label: t,
  summaryText: a,
  open: n,
  onToggle: o
}) {
  return /* @__PURE__ */ e.createElement("div", { className: be.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [be.toggle, n ? be.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": n
    },
    t
  ), n && /* @__PURE__ */ e.createElement("div", { className: be.panel }, /* @__PURE__ */ e.createElement("p", { className: be.text }, a)));
}
const Po = "_wrapper_96dw1_1", Oo = "_labelRow_96dw1_8", qo = "_label_96dw1_8", Go = "_value_96dw1_21", Wo = "_track_96dw1_27", zo = "_xs_96dw1_35", Ko = "_sm_96dw1_39", Ho = "_md_96dw1_43", Vo = "_square_96dw1_47", Uo = "_fill_96dw1_51", W = {
  wrapper: Po,
  labelRow: Oo,
  label: qo,
  value: Go,
  track: Wo,
  xs: zo,
  sm: Ko,
  md: Ho,
  square: Vo,
  fill: Uo
};
function _l({
  value: t,
  max: a = 100,
  label: n,
  color: o = "#3B82F6",
  gradient: r,
  size: s = "md",
  rounded: l = !0,
  height: d,
  trackColor: c
}) {
  const i = a > 0 ? a : 100, m = Math.min(100, Math.max(0, t / i * 100)), _ = r ? { width: `${m}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${m}%`, backgroundColor: o }, u = {
    ...d !== void 0 ? { height: d } : {},
    ...c !== void 0 ? { background: c } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: W.wrapper }, n && /* @__PURE__ */ e.createElement("div", { className: W.labelRow }, /* @__PURE__ */ e.createElement("span", { className: W.label }, n), /* @__PURE__ */ e.createElement("span", { className: W.value }, Math.round(m), "%")), /* @__PURE__ */ e.createElement("div", { className: [W.track, W[s], l ? "" : W.square].join(" "), style: u }, /* @__PURE__ */ e.createElement("div", { className: [W.fill, l ? "" : W.square].join(" "), style: _ })));
}
const Qo = "_list_aixh6_1", Yo = "_vertical_aixh6_8", Jo = "_horizontal_aixh6_13", Zo = "_item_aixh6_18", es = "_iconWrap_aixh6_41", ts = "_iconSvg_aixh6_51", as = "_spin_aixh6_56", ns = "_label_aixh6_70", os = "_item_active_aixh6_82", ss = "_item_done_aixh6_87", rs = "_connector_aixh6_91", cs = "_cardList_aixh6_114", ls = "_cardItem_aixh6_122", is = "_card_pending_aixh6_133", ds = "_card_active_aixh6_142", _s = "_card_done_aixh6_152", x = {
  list: Qo,
  vertical: Yo,
  horizontal: Jo,
  item: Zo,
  iconWrap: es,
  iconSvg: ts,
  spin: as,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: ns,
  item_active: os,
  item_done: ss,
  connector: rs,
  cardList: cs,
  cardItem: ls,
  card_pending: is,
  card_active: ds,
  card_done: _s
};
function ms({ status: t }) {
  return t === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : t === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [x.iconSvg, x.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function ml({
  steps: t,
  orientation: a = "vertical",
  variant: n = "timeline"
}) {
  const o = n === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [x.list, x[a], o ? x.cardList : ""].join(" ") }, t.map((r, s) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${r.label}-${s}`,
      className: [
        x.item,
        o ? x.cardItem : "",
        x[`item_${r.status}`],
        o ? x[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: x.iconWrap }, /* @__PURE__ */ e.createElement(ms, { status: r.status })),
    /* @__PURE__ */ e.createElement("span", { className: x.label }, r.label),
    !o && s < t.length - 1 && /* @__PURE__ */ e.createElement("span", { className: x.connector })
  )));
}
const us = "_wrapper_1ohmw_1", ps = "_icon_1ohmw_7", Es = "_dots_1ohmw_14", bs = "_dot_1ohmw_14", fs = "_sm_1ohmw_27", ys = "_md_1ohmw_32", te = {
  wrapper: us,
  icon: ps,
  dots: Es,
  dot: bs,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: fs,
  md: ys
};
function ul({ withIcon: t, size: a = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: te.wrapper }, t && /* @__PURE__ */ e.createElement("span", { className: te.icon }, t), /* @__PURE__ */ e.createElement("span", { className: [te.dots, te[a]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot })));
}
const gs = "_container_85404_1", hs = "_table_85404_9", vs = "_row_85404_31", ks = "_striped_85404_35", Ns = "_clickable_85404_43", As = "_alignLeft_85404_47", ws = "_alignCenter_85404_51", $s = "_alignRight_85404_55", xs = "_emptyCell_85404_59", z = {
  container: gs,
  table: hs,
  row: vs,
  striped: ks,
  clickable: Ns,
  alignLeft: As,
  alignCenter: ws,
  alignRight: $s,
  emptyCell: xs
};
function pl({
  columns: t,
  rows: a,
  striped: n = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const s = (l) => l === "center" ? z.alignCenter : l === "right" ? z.alignRight : z.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: z.container }, /* @__PURE__ */ e.createElement("table", { className: z.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, t.map((l) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: l.key,
      className: s(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, a.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: z.emptyCell, colSpan: t.length }, r)) : a.map((l, d) => {
    const c = [
      z.row,
      n && d % 2 === 1 ? z.striped : "",
      o ? z.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: d,
        className: c,
        onClick: o ? () => o(l, d) : void 0
      },
      t.map((i) => /* @__PURE__ */ e.createElement("td", { key: i.key, className: s(i.align) }, l[i.key]))
    );
  }))));
}
const Xs = "_grid_plbcd_1", Cs = "_cell_plbcd_6", Ss = "_primaryCell_plbcd_16", Bs = "_label_plbcd_21", Fs = "_value_plbcd_26", Is = "_note_plbcd_32", oe = {
  grid: Xs,
  cell: Cs,
  primaryCell: Ss,
  label: Bs,
  value: Fs,
  note: Is
};
function El({
  items: t,
  columns: a = 4,
  primaryFirst: n = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: s,
  valueColor: l,
  primaryBackground: d,
  primaryLabelColor: c,
  primaryValueColor: i,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: oe.grid,
      style: { gridTemplateColumns: `repeat(${a}, 1fr)` }
    },
    t.map((_, u) => {
      const b = n && u === 0, y = [oe.cell, b ? oe.primaryCell : ""].filter(Boolean).join(" "), E = {};
      o !== void 0 && (E.background = o), r !== void 0 && (E.borderColor = r), b && d !== void 0 && (E.background = d, E.borderColor = "transparent");
      const h = {};
      s !== void 0 && (h.color = s), b && c !== void 0 && (h.color = c);
      const w = {};
      l !== void 0 && (w.color = l), b && i !== void 0 && (w.color = i);
      const X = {};
      return b && m !== void 0 && (X.color = m), /* @__PURE__ */ e.createElement("div", { key: `${_.label}-${u}`, className: y, style: E }, /* @__PURE__ */ e.createElement("span", { className: oe.label, style: h }, _.label), /* @__PURE__ */ e.createElement("span", { className: oe.value, style: w }, _.value), _.note && /* @__PURE__ */ e.createElement("span", { className: oe.note, style: X }, _.note));
    })
  );
}
const js = "_button_16ajt_1", Ls = "_disabledSolid_16ajt_19", Ds = "_icon_16ajt_26", Ms = "_label_16ajt_32", Ts = "_fullWidth_16ajt_37", Rs = "_sm_16ajt_41", Ps = "_md_16ajt_47", Os = "_lg_16ajt_53", qs = "_primary_16ajt_59", Gs = "_secondary_16ajt_70", Ws = "_outline_16ajt_81", zs = "_ghost_16ajt_93", Ks = "_active_16ajt_104", Hs = "_colorOverride_16ajt_116", Vs = "_gradient_16ajt_126", Us = "_dashed_16ajt_135", Qs = "_pill_16ajt_139", L = {
  button: js,
  disabledSolid: Ls,
  icon: Ds,
  label: Ms,
  fullWidth: Ts,
  sm: Rs,
  md: Ps,
  lg: Os,
  primary: qs,
  secondary: Gs,
  outline: Ws,
  ghost: zs,
  active: Ks,
  colorOverride: Hs,
  gradient: Vs,
  dashed: Us,
  pill: Qs
};
function bl({
  variant: t = "primary",
  size: a = "md",
  icon: n,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: s = "dim",
  onClick: l,
  children: d,
  fullWidth: c = !1,
  type: i = "button",
  active: m = !1,
  color: _,
  background: u,
  borderColor: b,
  hoverColor: y,
  hoverBackground: E,
  gradient: h,
  borderStyle: w = "solid",
  shape: X = "rounded"
}) {
  const T = _ !== void 0 || b !== void 0 || y !== void 0 || E !== void 0, O = [
    L.button,
    L[t],
    L[a],
    c ? L.fullWidth : "",
    r && s === "solid" ? L.disabledSolid : "",
    m ? L.active : "",
    T ? L.colorOverride : "",
    h || u ? L.gradient : "",
    w === "dashed" ? L.dashed : "",
    X === "pill" ? L.pill : ""
  ].filter(Boolean).join(" "), q = {
    ..._ !== void 0 ? { "--ax-btn-color": _ } : {},
    ...b !== void 0 ? { "--ax-btn-border": b } : {},
    ...y !== void 0 ? { "--ax-btn-hover-color": y } : {},
    ...E !== void 0 ? { "--ax-btn-hover-bg": E } : {},
    ...h ? { background: `linear-gradient(135deg, ${h[0]}, ${h[1]})` } : {},
    ...u !== void 0 ? { background: u } : {}
  }, V = n && /* @__PURE__ */ e.createElement("span", { className: L.icon }, n);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: i,
      className: O,
      style: q,
      disabled: r,
      onClick: l
    },
    o === "leading" && V,
    /* @__PURE__ */ e.createElement("span", { className: L.label }, d),
    o === "trailing" && V
  );
}
const Ys = "_iconButton_1oiog_1", Js = "_sm_1oiog_18", Zs = "_md_1oiog_23", er = "_lg_1oiog_28", tr = "_plain_1oiog_33", ar = "_outline_1oiog_42", nr = "_circle_1oiog_53", or = "_bordered_1oiog_62", sr = "_tint_1oiog_73", rr = "_active_1oiog_81", cr = "_hoverBgOverride_1oiog_92", lr = "_gradient_1oiog_96", Y = {
  iconButton: Ys,
  sm: Js,
  md: Zs,
  lg: er,
  plain: tr,
  outline: ar,
  circle: nr,
  bordered: or,
  tint: sr,
  active: rr,
  hoverBgOverride: cr,
  gradient: lr
};
function fl({
  icon: t,
  title: a,
  active: n = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: s,
  onMouseDown: l,
  disabled: d = !1,
  color: c,
  hoverColor: i,
  bordered: m = !1,
  borderColor: _ = "#e2e8f0",
  borderHoverColor: u = "#3b82f6",
  tint: b = !1,
  tintColor: y = "#eef4ff",
  tintHoverColor: E = "#dbeafe",
  hoverBackground: h,
  gradient: w
}) {
  const X = typeof o == "number", T = [
    Y.iconButton,
    X ? "" : Y[o],
    Y[r],
    n ? Y.active : "",
    m ? Y.bordered : "",
    b ? Y.tint : "",
    h !== void 0 ? Y.hoverBgOverride : "",
    w ? Y.gradient : ""
  ].filter(Boolean).join(" "), O = {
    ...X ? { width: o, height: o } : {},
    ...c !== void 0 ? { "--ax-icon-color": c } : {},
    ...i !== void 0 ? { "--ax-icon-hover": i } : {},
    ...m ? { "--ax-icon-border": _, "--ax-icon-border-hover": u } : {},
    ...b ? { "--ax-icon-tint": y, "--ax-icon-tint-hover": E } : {},
    ...h !== void 0 ? { "--ax-icon-hover-bg": h } : {},
    ...w ? { background: `linear-gradient(135deg, ${w[0]}, ${w[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: T,
      style: O,
      onClick: s,
      onMouseDown: l,
      disabled: d,
      title: a,
      "aria-label": a
    },
    t
  );
}
const ir = "_control_1kv40_1", dr = "_option_1kv40_10", _r = "_active_1kv40_28", mr = "_sm_1kv40_37", ur = "_md_1kv40_43", pr = "_dot_1kv40_49", Er = "_count_1kv40_56", br = "_outline_1kv40_70", fr = "_outlineOption_1kv40_75", K = {
  control: ir,
  option: dr,
  active: _r,
  sm: mr,
  md: ur,
  dot: pr,
  count: Er,
  outline: br,
  outlineOption: fr
};
function yl({
  options: t,
  value: a,
  onChange: n,
  size: o = "md",
  variant: r = "filled",
  activeBackground: s,
  activeColor: l,
  activeBorderColor: d
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [K.control, K[o], r === "outline" ? K.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    t.map((c) => {
      const i = c.value === a, m = i ? {
        ...s !== void 0 ? { background: s } : {},
        ...l !== void 0 ? { color: l } : {},
        ...d !== void 0 ? { borderColor: d } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: c.value,
          type: "button",
          role: "tab",
          "aria-selected": i,
          className: [K.option, i ? K.active : "", r === "outline" ? K.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => n(c.value)
        },
        c.dot && /* @__PURE__ */ e.createElement("span", { className: K.dot, style: { backgroundColor: c.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: K.label }, c.label),
        typeof c.count == "number" && /* @__PURE__ */ e.createElement("span", { className: K.count }, c.count)
      );
    })
  );
}
const yr = "_chip_8jgxm_1", gr = "_clickable_8jgxm_14", hr = "_suggested_8jgxm_23", vr = "_readonly_8jgxm_33", kr = "_plusIcon_8jgxm_39", Nr = "_label_8jgxm_45", Ar = "_removeButton_8jgxm_50", se = {
  chip: yr,
  clickable: gr,
  default: "_default_8jgxm_18",
  suggested: hr,
  readonly: vr,
  plusIcon: kr,
  label: Nr,
  removeButton: Ar
};
function gl({
  label: t,
  variant: a = "default",
  onRemove: n,
  onClick: o,
  background: r,
  textColor: s,
  borderColor: l
}) {
  const d = [se.chip, se[a], o ? se.clickable : ""].filter(Boolean).join(" "), i = r !== void 0 || s !== void 0 || l !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...s !== void 0 ? { color: s } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, m = a !== "readonly" && !!n, _ = /* @__PURE__ */ e.createElement(e.Fragment, null, a === "suggested" && /* @__PURE__ */ e.createElement("span", { className: se.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: se.label }, t), m && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: se.removeButton,
      "aria-label": `remove ${t}`,
      onClick: (u) => {
        u.stopPropagation(), n == null || n();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: d,
      style: i,
      onClick: o,
      onKeyDown: (u) => {
        (u.key === "Enter" || u.key === " ") && (u.preventDefault(), o());
      }
    },
    _
  ) : /* @__PURE__ */ e.createElement("span", { className: d, style: i }, _);
}
const wr = "_wrapper_15dm4_1", $r = "_disabled_15dm4_8", xr = "_track_15dm4_13", Xr = "_checked_15dm4_30", Cr = "_thumb_15dm4_34", Sr = "_label_15dm4_50", re = {
  wrapper: wr,
  disabled: $r,
  track: xr,
  checked: Xr,
  thumb: Cr,
  label: Sr
};
function hl({
  checked: t,
  onChange: a,
  labelOn: n,
  labelOff: o,
  disabled: r = !1,
  color: s
}) {
  const l = t ? n : o;
  return /* @__PURE__ */ e.createElement("label", { className: [re.wrapper, r ? re.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": t,
      disabled: r,
      className: [re.track, t ? re.checked : ""].filter(Boolean).join(" "),
      style: t && s !== void 0 ? { background: s } : void 0,
      onClick: () => !r && a(!t)
    },
    /* @__PURE__ */ e.createElement("span", { className: re.thumb })
  ), l && /* @__PURE__ */ e.createElement("span", { className: re.label }, l));
}
const Br = "_card_1uh3t_1", Fr = "_active_1uh3t_24", Ir = "_iconChip_1uh3t_29", jr = "_body_1uh3t_41", Lr = "_label_1uh3t_48", Dr = "_description_1uh3t_54", ce = {
  card: Br,
  active: Fr,
  iconChip: Ir,
  body: jr,
  label: Lr,
  description: Dr
};
function vl(t) {
  const { icon: a, label: n, description: o, active: r = !1, onClick: s } = t;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${ce.card} ${r ? ce.active : ""}`,
      onClick: s,
      "aria-pressed": r
    },
    /* @__PURE__ */ e.createElement("span", { className: ce.iconChip }, a),
    /* @__PURE__ */ e.createElement("span", { className: ce.body }, /* @__PURE__ */ e.createElement("span", { className: ce.label }, n), o && /* @__PURE__ */ e.createElement("span", { className: ce.description }, o))
  );
}
const Mr = "_breadcrumb_zkol9_1", Tr = "_list_zkol9_6", Rr = "_item_zkol9_16", Pr = "_link_zkol9_22", Or = "_plain_zkol9_43", qr = "_current_zkol9_48", Gr = "_separator_zkol9_54", ae = {
  breadcrumb: Mr,
  list: Tr,
  item: Rr,
  link: Pr,
  plain: Or,
  current: qr,
  separator: Gr
};
function kl(t) {
  const { items: a, separator: n = "/", textColor: o, hoverColor: r, currentColor: s } = t, l = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...s !== void 0 ? { "--ax-bc-current": s } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: ae.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ e.createElement("ol", { className: ae.list }, a.map((d, c) => {
    const i = c === a.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: c, className: ae.item }, i ? /* @__PURE__ */ e.createElement("span", { className: ae.current, "aria-current": "page" }, d.label) : d.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: ae.link,
        onClick: d.onClick
      },
      d.label
    ) : /* @__PURE__ */ e.createElement("span", { className: ae.plain }, d.label), !i && /* @__PURE__ */ e.createElement("span", { className: ae.separator, "aria-hidden": "true" }, n));
  })));
}
const Wr = "_treeItem_1ouqz_1", zr = "_active_1ouqz_18", Kr = "_chevron_1ouqz_28", Hr = "_chevronExpanded_1ouqz_48", Vr = "_chevronSpacer_1ouqz_52", Ur = "_icon_1ouqz_57", Qr = "_label_1ouqz_69", Yr = "_count_1ouqz_76", Jr = "_dark_1ouqz_86", H = {
  treeItem: Wr,
  active: zr,
  chevron: Kr,
  chevronExpanded: Hr,
  chevronSpacer: Vr,
  icon: Ur,
  label: Qr,
  count: Yr,
  dark: Jr
};
function Nl(t) {
  const {
    icon: a,
    label: n,
    count: o,
    indent: r = 0,
    active: s = !1,
    expandable: l = !1,
    expanded: d = !1,
    theme: c = "light",
    onToggleExpand: i,
    onClick: m
  } = t, _ = (b) => {
    b.stopPropagation(), i == null || i();
  }, u = c === "dark" ? H.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${H.treeItem} ${u} ${s ? H.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": s,
      "aria-expanded": l ? d : void 0
    },
    l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${H.chevron} ${d ? H.chevronExpanded : ""}`,
        onClick: _,
        "aria-label": d ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: H.chevronSpacer }),
    a && /* @__PURE__ */ e.createElement("span", { className: H.icon }, a),
    /* @__PURE__ */ e.createElement("span", { className: H.label }, n),
    typeof o == "number" && /* @__PURE__ */ e.createElement("span", { className: H.count }, o)
  );
}
const Zr = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function He(t) {
  return Array.from(t.querySelectorAll(Zr)).filter((a) => a.getClientRects().length > 0 && getComputedStyle(a).visibility !== "hidden");
}
let Ve = 0, Ue = "";
function rt(t) {
  const a = J(null), n = J(t);
  n.current = t;
  const o = J(void 0);
  return o.current === void 0 && (o.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var d;
    const s = a.current, l = (d = o.current) != null ? d : null;
    return s && !s.contains(document.activeElement) && (He(s)[0] || s).focus(), Ve++ === 0 && (Ue = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Ve === 0 && (document.body.style.overflow = Ue), l && l.isConnected && typeof l.focus == "function" && l.focus();
    };
  }, []), { dialogRef: a, onKeyDown: (s) => {
    const l = a.current;
    if (!l) return;
    if (s.key === "Escape") {
      s.stopPropagation(), n.current();
      return;
    }
    if (s.key !== "Tab" || !l.contains(s.target)) return;
    const d = He(l);
    if (d.length === 0) {
      s.preventDefault(), l.focus();
      return;
    }
    const c = d[0], i = d[d.length - 1], m = document.activeElement;
    s.shiftKey && (m === c || m === l) ? (s.preventDefault(), i.focus()) : !s.shiftKey && m === i && (s.preventDefault(), c.focus());
  } };
}
const ec = "_backdrop_gstyy_1", tc = "_panel_gstyy_9", ac = "_right_gstyy_21", nc = "_left_gstyy_27", oc = "_header_gstyy_51", sc = "_icon_gstyy_59", rc = "_titleGroup_gstyy_66", cc = "_kicker_gstyy_71", lc = "_title_gstyy_66", ic = "_subtitle_gstyy_87", dc = "_closeButton_gstyy_93", _c = "_body_gstyy_115", mc = "_footer_gstyy_123", I = {
  backdrop: ec,
  panel: tc,
  right: ac,
  left: nc,
  header: oc,
  icon: sc,
  titleGroup: rc,
  kicker: cc,
  title: lc,
  subtitle: ic,
  closeButton: dc,
  body: _c,
  footer: mc
};
function Al(t) {
  return t.open ? /* @__PURE__ */ e.createElement(uc, { ...t }) : null;
}
function uc({
  onClose: t,
  icon: a,
  kicker: n,
  title: o,
  titleSize: r,
  titleWeight: s,
  subtitle: l,
  footer: d,
  children: c,
  side: i = "right",
  headerBackground: m,
  topOffset: _
}) {
  const { dialogRef: u, onKeyDown: b } = rt(t), y = Ye("ax-drawer-t"), E = [I.panel, i === "left" ? I.left : I.right].filter(Boolean).join(" "), h = {
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  }, w = _ !== void 0 ? { top: _, height: `calc(100vh - ${_}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: I.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: u,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": y,
      className: E,
      style: w,
      onClick: (X) => X.stopPropagation(),
      onKeyDown: b
    },
    /* @__PURE__ */ e.createElement("div", { className: I.header, style: m !== void 0 ? { background: m } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: I.icon }, a), /* @__PURE__ */ e.createElement("div", { className: I.titleGroup }, n && /* @__PURE__ */ e.createElement("p", { className: I.kicker }, n), /* @__PURE__ */ e.createElement("h2", { className: I.title, id: y, style: h }, o), l && /* @__PURE__ */ e.createElement("p", { className: I.subtitle }, l)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: I.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: I.body }, c),
    d && /* @__PURE__ */ e.createElement("div", { className: I.footer }, d)
  ));
}
const pc = "_backdrop_6kso7_1", Ec = "_menu_6kso7_8", bc = "_alignRight_6kso7_24", fc = "_alignLeft_6kso7_28", yc = "_item_6kso7_32", gc = "_itemIcon_6kso7_50", hc = "_itemText_6kso7_59", vc = "_itemLabel_6kso7_66", kc = "_itemDescription_6kso7_72", Nc = "_danger_6kso7_77", R = {
  backdrop: pc,
  menu: Ec,
  alignRight: bc,
  alignLeft: fc,
  item: yc,
  itemIcon: gc,
  itemText: hc,
  itemLabel: vc,
  itemDescription: kc,
  danger: Nc
};
function wl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Ac, { ...t }) : null;
}
function Ac({
  onClose: t,
  items: a,
  anchor: n = "right"
}) {
  const o = J(null), r = J(void 0);
  r.current === void 0 && (r.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var i, m, _;
    const c = (i = r.current) != null ? i : null;
    return (_ = (m = o.current) == null ? void 0 : m.querySelector("button")) == null || _.focus(), () => {
      c && c.isConnected && typeof c.focus == "function" && c.focus();
    };
  }, []);
  const s = [R.menu, n === "left" ? R.alignLeft : R.alignRight].filter(Boolean).join(" "), l = (c) => {
    c.onClick(), t();
  }, d = (c) => {
    var u, b;
    const i = Array.from((b = (u = o.current) == null ? void 0 : u.querySelectorAll("button")) != null ? b : []), m = i.indexOf(document.activeElement), _ = (y) => {
      var E;
      c.preventDefault(), (E = i[(y + i.length) % i.length]) == null || E.focus();
    };
    c.key === "ArrowDown" ? _(m + 1) : c.key === "ArrowUp" ? _(m <= 0 ? i.length - 1 : m - 1) : c.key === "Home" ? _(0) : c.key === "End" ? _(i.length - 1) : (c.key === "Escape" || c.key === "Tab") && (c.key === "Escape" && c.preventDefault(), t());
  };
  return /* @__PURE__ */ e.createElement(ct, null, /* @__PURE__ */ e.createElement("div", { className: R.backdrop, onClick: t }), /* @__PURE__ */ e.createElement("div", { ref: o, role: "menu", className: s, onClick: (c) => c.stopPropagation(), onKeyDown: d }, a.map((c, i) => {
    const m = [R.item, c.danger ? R.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: i,
        type: "button",
        role: "menuitem",
        className: m,
        onClick: () => l(c)
      },
      c.icon && /* @__PURE__ */ e.createElement("span", { className: R.itemIcon }, c.icon),
      /* @__PURE__ */ e.createElement("span", { className: R.itemText }, /* @__PURE__ */ e.createElement("span", { className: R.itemLabel }, c.label), c.description && /* @__PURE__ */ e.createElement("span", { className: R.itemDescription }, c.description))
    );
  })));
}
const wc = "_backdrop_3pc9i_1", $c = "_card_3pc9i_12", xc = "_header_3pc9i_23", Xc = "_icon_3pc9i_31", Cc = "_titleGroup_3pc9i_38", Sc = "_title_3pc9i_38", Bc = "_subtitle_3pc9i_50", Fc = "_closeButton_3pc9i_56", Ic = "_body_3pc9i_78", jc = "_footer_3pc9i_85", P = {
  backdrop: wc,
  card: $c,
  header: xc,
  icon: Xc,
  titleGroup: Cc,
  title: Sc,
  subtitle: Bc,
  closeButton: Fc,
  body: Ic,
  footer: jc
};
function $l(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Lc, { ...t }) : null;
}
function Lc({
  onClose: t,
  icon: a,
  title: n,
  subtitle: o,
  footer: r,
  width: s = 480,
  children: l
}) {
  const { dialogRef: d, onKeyDown: c } = rt(t), i = Ye("ax-modal-t"), m = typeof s == "number" ? `${s}px` : s;
  return /* @__PURE__ */ e.createElement("div", { className: P.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: d,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": i,
      className: P.card,
      style: { width: m },
      onClick: (_) => _.stopPropagation(),
      onKeyDown: c
    },
    /* @__PURE__ */ e.createElement("div", { className: P.header }, a && /* @__PURE__ */ e.createElement("span", { className: P.icon }, a), /* @__PURE__ */ e.createElement("div", { className: P.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: P.title, id: i }, n), o && /* @__PURE__ */ e.createElement("p", { className: P.subtitle }, o)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: P.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: P.body }, l),
    r && /* @__PURE__ */ e.createElement("div", { className: P.footer }, r)
  ));
}
export {
  we as ACTIVE_AFFILIATION_KEY_PREFIX,
  ht as ACTIVE_COM_HEADER,
  vt as ACTIVE_DEPT_HEADER,
  vl as AXActionCard,
  Jc as AXAiIconBadge,
  ll as AXAiSuggestionBanner,
  st as AXAvatar,
  Zc as AXAvatarStack,
  el as AXBadge,
  kl as AXBreadcrumb,
  bl as AXButton,
  Uc as AXCardPanel,
  tl as AXCommentRow,
  Hc as AXCommentThread,
  pl as AXDataTable,
  Qc as AXDivider,
  Al as AXDrawer,
  wl as AXDropdownMenu,
  Cl as AXERP_EMPTY_SET_TEXT,
  il as AXEmptyState,
  Wl as AXErpAccordion,
  zl as AXErpActionMenu,
  Kl as AXErpAiAnswerPanel,
  Hl as AXErpBanner,
  Vl as AXErpBarChart,
  Ul as AXErpButton,
  Ql as AXErpCalculatorModal,
  Yl as AXErpCalculatorProvider,
  Jl as AXErpCalendar,
  Zl as AXErpCard,
  ei as AXErpCheckGroup,
  ti as AXErpCheckList,
  ai as AXErpCheckbox,
  ni as AXErpCodeBadge,
  oi as AXErpCodePicker,
  si as AXErpContextHelp,
  ri as AXErpContextMenu,
  ci as AXErpCriticalAlert,
  li as AXErpCsvButton,
  ii as AXErpCsvPick,
  di as AXErpDataTable,
  _i as AXErpDatePicker,
  mi as AXErpDateRange,
  ui as AXErpDonutChart,
  pi as AXErpDropArea,
  Ei as AXErpEmptySet,
  bi as AXErpError,
  fi as AXErpField,
  yi as AXErpFileButton,
  gi as AXErpFileDrop,
  hi as AXErpFilterBand,
  vi as AXErpFormModal,
  ki as AXErpFormRow,
  Ni as AXErpFormSection,
  Ai as AXErpGantt,
  wi as AXErpGisuField,
  $i as AXErpGlyph,
  xi as AXErpGrid,
  Xi as AXErpGridStatus,
  Ci as AXErpHint,
  Si as AXErpIcon,
  Bi as AXErpIconButton,
  Fi as AXErpImageThumbs,
  Ii as AXErpKanban,
  ji as AXErpKpiTile,
  Li as AXErpKpiTileGroup,
  Di as AXErpLinkButton,
  Mi as AXErpLoadMore,
  Ti as AXErpMainScreen,
  Ri as AXErpMenuAreaHead,
  Pi as AXErpMenuGroup,
  Oi as AXErpMiniCalendar,
  qi as AXErpModal,
  Gi as AXErpMoneyInput,
  Wi as AXErpMsg,
  zi as AXErpMultiSelect,
  Ki as AXErpNote,
  Hi as AXErpOverviewGrid,
  Vi as AXErpPage,
  Ui as AXErpPageBody,
  Qi as AXErpPageFrame,
  Yi as AXErpPagination,
  Ji as AXErpPill,
  Zi as AXErpPopover,
  ed as AXErpProgressBar,
  td as AXErpProposalBanner,
  ad as AXErpProposalCards,
  nd as AXErpProposalList,
  od as AXErpProposalModal,
  sd as AXErpQtyInput,
  rd as AXErpQuickMenu,
  cd as AXErpRadioGroup,
  ld as AXErpReadonly,
  id as AXErpReadout,
  dd as AXErpSaveBar,
  _d as AXErpSearchBar,
  md as AXErpSelect,
  ud as AXErpShortcutHelp,
  pd as AXErpSideBar,
  Ed as AXErpSidePanel,
  bd as AXErpSidePanelGroup,
  fd as AXErpSkipLink,
  yd as AXErpSortAnnounce,
  gd as AXErpSortButton,
  hd as AXErpSortTh,
  vd as AXErpSpinner,
  kd as AXErpStartGuide,
  Nd as AXErpStatCard,
  Ad as AXErpStateBadge,
  wd as AXErpStepIndicator,
  $d as AXErpSummaryCard,
  xd as AXErpSummaryList,
  Xd as AXErpSwitch,
  Cd as AXErpTabs,
  Sd as AXErpTag,
  Bd as AXErpTagList,
  Fd as AXErpTextInput,
  Id as AXErpTitleBar,
  jd as AXErpToastProvider,
  Ld as AXErpToggle,
  Dd as AXErpTooltip,
  Md as AXErpTreeCell,
  Td as AXErpVerify,
  Rd as AXErpVirtualBody,
  Pd as AXErpVisuallyHidden,
  Od as AXErpWeekStepper,
  qd as AXErpWeekStrip,
  dl as AXExpandableSummary,
  al as AXFileChip,
  pn as AXFileTypeIcon,
  fl as AXIconButton,
  El as AXKeyValueGrid,
  nl as AXKeyValueRow,
  ol as AXListRow,
  $l as AXModal,
  Yc as AXPanelHeader,
  sl as AXPersonRow,
  _l as AXProgressBar,
  rl as AXRankingRow,
  Gd as AXSearchInput,
  yl as AXSegmentedControl,
  cl as AXStatusBadge,
  ml as AXStepProgress,
  gl as AXTagChip,
  hl as AXToggleSwitch,
  Nl as AXTreeItem,
  ul as AXTypingDots,
  Wd as AX_ERP_CALENDAR_KO,
  zd as AX_ERP_DIRTY_MESSAGE,
  Kd as AX_ERP_SHORTCUTS,
  zc as CurrencyUnit,
  Hd as ERP_AREA_BASE,
  Vd as ERP_AREA_MIN,
  Ud as ERP_AREA_MIN_PINNED,
  Qd as ERP_HOST_SIDE,
  Yd as ERP_HOST_TOP,
  Jd as ERP_PAGE_MIN_WIDTH,
  Zd as ERP_PAGE_MIN_WIDTH_MAX,
  e_ as ERP_VIEWPORT_BASE,
  t_ as ERP_VIEWPORT_MIN,
  je as GW_ORIGIN,
  a_ as JAPANESE_ERAS,
  n_ as OBTPortal,
  o_ as OBTResizeContainer,
  s_ as OBTResizeSensor,
  ge as REFRESH_KEY,
  Ce as SESSION_EXPIRED_EVENT,
  Ie as TOKEN_KEY,
  kt as activeAffiliationHeaders,
  Sl as amDigits,
  Bl as amNumber,
  le as authorizedFetch,
  r_ as axErpAddDays,
  c_ as axErpAriaSort,
  l_ as axErpAutoLineAm,
  i_ as axErpCalendarLocale,
  d_ as axErpChangedKeys,
  __ as axErpCodeDisplay,
  m_ as axErpCodeLabel,
  u_ as axErpCodeNameOf,
  p_ as axErpCompareSortValue,
  E_ as axErpDownload,
  Fl as axErpEmptySetText,
  b_ as axErpFileName,
  f_ as axErpGisuLabel,
  y_ as axErpHttpMessage,
  g_ as axErpIsHelpKey,
  h_ as axErpKeepInPlace,
  v_ as axErpKpiColumns,
  k_ as axErpMenuItem,
  N_ as axErpMenuSection,
  A_ as axErpMergeBase,
  w_ as axErpNextSort,
  $_ as axErpPageCount,
  x_ as axErpPageItems,
  X_ as axErpParsePage,
  C_ as axErpQtyDecimals,
  S_ as axErpQtyFormat,
  B_ as axErpQtyOutOfRange,
  F_ as axErpQtyParse,
  I_ as axErpQtyRound,
  j_ as axErpQtyStep,
  L_ as axErpQtyTimesUnit,
  D_ as axErpRangeValid,
  M_ as axErpRovingMove,
  T_ as axErpRowActivate,
  R_ as axErpSameValues,
  P_ as axErpSaveBlob,
  O_ as axErpSaveCsv,
  q_ as axErpSortForest,
  G_ as axErpSortMessage,
  W_ as axErpSortValue,
  z_ as axErpSubmitShortcutLabel,
  K_ as axErpTableToCsv,
  H_ as axErpTotalLabel,
  V_ as axErpWeekOf,
  U_ as clampErpPageMinWidth,
  pt as clearTokens,
  Rc as colors,
  Pc as configureAuth,
  Kc as configureComments,
  Q_ as csvFormulaGuard,
  Y_ as csvNumber,
  _t as currencyDigits,
  lt as currencyText,
  Le as currentUsername,
  $e as decodeClaims,
  Wc as ensureBaseCurrency,
  J_ as eraOf,
  Z_ as eraShortDate,
  em as eraYearLabel,
  Il as fmtAm,
  tm as fmtDt,
  jl as fmtDtMin,
  dt as fmtMoney,
  Ll as fmtMoneyText,
  Dl as fmtNum,
  Ml as fmtNumBlank,
  Tl as fmtNumDash,
  Rl as fmtYen,
  De as getActiveAffiliation,
  Pl as getBaseCurrency,
  gt as getFreshToken,
  et as getStoredToken,
  mt as isExpired,
  Ze as isRefreshExpired,
  $t as isReply,
  am as measureMoneyMetrics,
  nm as moneyColWidth,
  om as moneyColWidthForDigits,
  it as moneyUnit,
  fe as notifySessionExpired,
  Gc as onActiveAffiliationChange,
  Oc as onSessionExpired,
  Nt as pickCurrencyCode,
  at as refreshTokens,
  ut as saveTokens,
  Ol as setAXErpEmptySetText,
  qc as setActiveAffiliation,
  Qe as setBaseCurrency,
  bt as startRefreshExpiryWatch,
  tt as stopRefreshExpiryWatch,
  sm as textColWidth,
  rm as textWidth,
  At as toCurrency,
  ql as toHalfWidth,
  cm as todayLocal,
  lm as useAXErpBusy,
  im as useAXErpCalculator,
  dm as useAXErpConfirm,
  _m as useAXErpDirtyGuard,
  mm as useAXErpEditor,
  um as useAXErpFilePicker,
  pm as useAXErpNotice,
  Em as useAXErpPaged,
  bm as useAXErpQuery,
  fm as useAXErpQuickMenu,
  ym as useAXErpRovingGrid,
  gm as useAXErpRunLock,
  hm as useAXErpShortcutHelp,
  vm as useAXErpSubmitShortcut,
  km as useAXErpToast,
  Nm as useAXErpTree,
  Ye as useAXErpUid,
  Vc as useCommentCounts,
  Ft as useComments,
  wt as useCurrency
};
